import {
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalHeader,
    ModalBody,
    FormControl,
    FormLabel,
    ModalFooter,
    Button,
    useDisclosure,
    Input,
} from "@chakra-ui/react";
import { useContext, useState } from "react";
import { MortgageStatementModal } from "./MortgageStatementModal";
import moment from "moment";
import { LoanContext } from "providers/loan";

interface MortgageStatementSearchModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export function MortgageStatementSearchModal({
    isOpen,
    onClose,
}: MortgageStatementSearchModalProps) {
    const { loan } = useContext(LoanContext);

    const [lastStatementDate, setLastStatementDate] = useState<string>(
        moment().format("YYYY-MM-DD")
    );

    const {
        isOpen: isMorgageStatementOpen,
        onOpen: openMorgageStatement,
        onClose: closeMorgageStatement,
    } = useDisclosure();

    const handleSubmit = (): void => {
        openMorgageStatement();
    };

    const handleMortgageStatementClose = (): void => {
        closeMorgageStatement();
        onClose();
    };

    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} size="xl">
                <ModalOverlay />
                <ModalContent
                    as="form"
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                    noValidate
                >
                    <ModalCloseButton />
                    <ModalHeader>
                        Mortgage Statement
                        <Text fontSize="16px" fontWeight="300">
                            View and download statements
                        </Text>
                    </ModalHeader>
                    <ModalBody>
                        <FormControl>
                            <FormLabel>Last Statement Date</FormLabel>
                            <Input
                                type="date"
                                variant="outline"
                                value={lastStatementDate}
                                onChange={(e) =>
                                    setLastStatementDate(e.target.value)
                                }
                            />
                        </FormControl>
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button onClick={onClose} variant="outline">
                            Close
                        </Button>
                        <Button type="submit">View Statement</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            {isMorgageStatementOpen && (
                <MortgageStatementModal
                    onClose={handleMortgageStatementClose}
                    lastStatementDate={lastStatementDate}
                    isOpen={isMorgageStatementOpen}
                />
            )}
        </>
    );
}
